<template>
  <div class="sb_age-gate_checkbox">
    <label class="sb_checkbox">
      <slot></slot>
      <span class="sb_checkbox_checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
  .sb_checkbox {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    user-select: none;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

    }

    &_checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 25px;
      width: 25px;
      background-color: #fff;
      border-radius: 4px;
      transition: background-color .2s ease;

      &:after {
        content: "";
        position: absolute;
        display: none;
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
      }
    }

    &:hover {
      input ~ .sb_checkbox_checkmark {
        background-color: #ccc;
      }
    }
    input:checked ~ .sb_checkbox_checkmark {
      background-color: #2196F3;
      &:after {
        display: block;
      }
    }
  }
</style>
